import { render, staticRenderFns } from "./TiptapToolbarDocumentLink.vue?vue&type=template&id=2809cd34"
import script from "./TiptapToolbarDocumentLink.vue?vue&type=script&setup=true&lang=js"
export * from "./TiptapToolbarDocumentLink.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports